export default __webpack_public_path__ + "static/media/TouchOne.048d45ec.svg";